import * as tool from "./_tools";
import Swiper, {Navigation, Pagination} from "swiper";

const classes = {
    menuOpened: "ekit-dropdown-open-onclick",
    dropdownOpened: "elementskit-dropdown-open",
};

/* Megamenu fixed */

function handleFixedHeader() {
    const elem__header = document.querySelector(".elementor-element-9210c19")
    let scrolledDownOnce = false;

    function addClassOnFirstScrollDown() {
        if (!scrolledDownOnce && window.scrollY > 0) {
            elem__header.classList.add('header-fixed');
            scrolledDownOnce = true;
            // Ajoute une légère pause pour permettre la transition de se produire
            setTimeout(() => {
                elem__header.style.top = '0'; // Déplace le header en vue
            }, 50); // 50ms de délai, ajustez selon vos besoins
        }
    }

    function removeClassOnScrollToTop() {
        if (scrolledDownOnce && window.scrollY === 0) {
            elem__header.classList.remove('header-fixed');
            elem__header.removeAttribute('style');
            scrolledDownOnce = false;
        }
    }

    window.addEventListener('scroll', function () {
        addClassOnFirstScrollDown();
        removeClassOnScrollToTop();
    });
}


/* Megamenu Opacity */

function addOpacityOnClickMegamenu() {
    const elem__body = document.body;

    elem__body.insertAdjacentHTML(
        "afterbegin",
        `<div id="opacity-megamenu"></div>`
    );

    const elem__bodyOpacityMegamenu =
        document.querySelector("#opacity-megamenu");

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class"
            ) {
                handleMegamenuOpener();
                break; // On arrête la boucle après le premier changement détecté
            }
        }
    });

    document
        .querySelectorAll(
            `#menu-menu-principal .elementskit-megamenu-panel, #menu-menu-cache .elementskit-megamenu-panel`
        )
        .forEach((el) => {
            observer.observe(el, {attributes: true}); // Observer les changements de classe
        });

    function handleMegamenuOpener() {
        let isOpen = false;
        document
            .querySelectorAll(
                `#menu-menu-principal .elementskit-megamenu-panel, #menu-menu-cache .elementskit-megamenu-panel`
            )
            .forEach((el) => {
                if (el.classList.contains("ekit-dropdown-open-onclick")) {
                    isOpen = true;
                }
            });
        if (isOpen) {
            elem__bodyOpacityMegamenu.classList.add("opacity-megamenu");
        } else {
            elem__bodyOpacityMegamenu.classList.remove("opacity-megamenu");
        }
    }
}

function watchClassChange() {
    const successDiv = document.querySelector('.wpcf7-form');
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            // Vérifier uniquement les changements de classe
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (successDiv.classList.contains("sent")) {
                    window.scrollTo(0, 0); // Scroll en haut de la page
                }
            }
        });
    });

    // Configuration de l'observateur pour observer les mutations d'attribut (classe)
    const config = {attributes: true};

    // Commencer à observer la div cible
    observer.observe(successDiv, config);
}

/* Override la fonction de scroll pour activer les list-item-text d'elementor pour la table des matières */
function overrideScrollTableOfContents() {
    window.addEventListener("load", () => {
        var activeSectionElement = null;
        const elem__listItemText = document.querySelectorAll(
            ".elementor-element-53688b1 .elementor-toc__list-item-text"
        );
        
        if(elem__listItemText){
        elem__listItemText[0].classList.add("table-of-contents-active");

        elem__listItemText.forEach((el) => {
            el.addEventListener("click", (event) => {

                event.preventDefault(); // Empêcher la modification de l'URL

                elem__listItemText.forEach((item) => {
                    item.classList.remove("table-of-contents-active");
                });
                el.classList.add("table-of-contents-active")

                // Récupérer l'ID de la section cible
                const targetId = el.getAttribute("href").slice(1);
                const targetSection = document.getElementById(targetId);

                // Si la section cible existe, effectuer un scroll vers elle
                if (targetSection) {
                    // Calculer la position avec un décalage de 100px
                    const offset = 150; // Décalage souhaité
                    const targetPosition =
                        targetSection.getBoundingClientRect().top +
                        window.scrollY -
                        offset;

                    // Défilement fluide vers la position calculée
                    window.scrollTo({
                        top: targetPosition,
                        behavior: "smooth",
                    });
                }

                activeSectionElement = targetSection;
            });
        });
    }


        var observeElementsInViewport = (function (docElm) {
            var viewportHeight = docElm.clientHeight;

            return function (e, options) {
                var inViewportElements = [],
                    i;

                if (e && e.type === "resize") viewportHeight = docElm.clientHeight;

                for (i = options.elements.length; i--;) {
                    var element = options.elements[i],
                        position = element.getBoundingClientRect(),
                        topPercentage = (position.top / viewportHeight) * 100,
                        bottomPercentage = (position.bottom / viewportHeight) * 100,
                        middle = (topPercentage + bottomPercentage) / 2,
                        inViewport =
                            middle > options.zone[0] && middle < 100 - options.zone[1];

                    const elementId = element.getAttribute("id");
                    const linkToAddClass = document.querySelector(
                        `a[href='#${elementId}']`
                    );

                    if (inViewport) {
                        if (activeSectionElement !== element) {
                            // Remove class from the previously active element
                            if (activeSectionElement) {
                                const prevElementId = activeSectionElement.getAttribute("id");
                                const prevLinkToRemoveClass = document.querySelector(
                                    `a[href='#${prevElementId}']`
                                );
                                prevLinkToRemoveClass.classList.remove(options.markedClass);
                            }

                            // Add class to the current active element
                            linkToAddClass.classList.add(options.markedClass);
                            activeSectionElement = element;
                        }

                        inViewportElements.push(element);
                    }
                }
            };
        })(document.documentElement);

        ////////////////////////////////////
        // How to use:

        let lastScrollTop = window.scrollY || document.documentElement.scrollTop;

        window.addEventListener("scroll", function () {
            let st = window.scrollY || document.documentElement.scrollTop;

            let scrollDirection = st > lastScrollTop ? "down" : "up";

            let scrollZone;
            if (scrollDirection === "down") {
                scrollZone = [40, 40];
            } else {
                scrollZone = [0, 80];
            }

            observeScroll(scrollZone);
            lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        });

        window.addEventListener("resize", function () {
            let scrollDirection = "down"; // default for resize
            let scrollZone = [40, 40]; // default for resize

            observeScroll(scrollZone);
        });

        function observeScroll(zone) {
            observeElementsInViewport(null, {
                elements: document.querySelectorAll(".elementor-menu-anchor"),
                markedClass: "table-of-contents-active",
                zone: zone, // percentage distance from top & bottom
            });
        }
    });
}

/* simuler clique sur l'ensemble du container pour activer l'animation sur le sommaire dans les pages single blog */

function simulateClickSummaryBlog() {
    const elem__summaryWrapper = document.querySelector(
        ".elementor-element-53688b1"
    );

    if (elem__summaryWrapper) {
        const elem__summaryChevrons = elem__summaryWrapper.querySelectorAll(
            ".elementor-toc__toggle-button"
        );
        const elem__summaryContent = elem__summaryWrapper.querySelector(
            ".elementor-toc__body"
        );

        if (elem__summaryChevrons.length > 0) {
            elem__summaryWrapper.addEventListener("click", (event) => {
                const isClickOnChevron = Array.from(elem__summaryChevrons).some(
                    (chevron) => chevron.contains(event.target)
                );

                if (
                    !isClickOnChevron &&
                    !elem__summaryContent.contains(event.target)
                ) {
                    const chevronWithNoDisplay = Array.from(elem__summaryChevrons).find(
                        (chevron) => window.getComputedStyle(chevron).display !== "none"
                    );

                    if (chevronWithNoDisplay) {
                        chevronWithNoDisplay.click();
                    }
                }
            });
        }
    }
}

/* Scroll en haut du boutons cliqué dans l'accordéon si ce dernier n'est plus visible à l'écran */

function scrollIfAccordionNotVisible() {
    const accordions = document.querySelectorAll(
        ".faq-header.accordion-header"
    );
    const accordions2 = document.querySelectorAll(".elementor-tab-title");
    let headerHeight = 0;

    if (
        window.matchMedia("(max-width: 767px)").matches &&
        document.querySelector(".elementor-element-7ff216b")
    ) {
        headerHeight = document.querySelector(
            ".elementor-element-7ff216b"
        ).offsetHeight;
    }

    function estVisible(element) {
        const rect = element.getBoundingClientRect();
        const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

        const vertVisible = rect.bottom > headerHeight && rect.top < windowHeight;

        return vertVisible;
    }

    function handleAccordionsItems(elems) {
        elems.forEach((accordion) => {
            accordion.addEventListener("click", function () {
                setTimeout(() => {
                    const estElementVisible = estVisible(accordion);
                    if (!estElementVisible) {
                        const btnPosition =
                            this.getBoundingClientRect().top + window.scrollY;
                        window.scroll({
                            top: btnPosition - headerHeight,
                            behavior: "smooth",
                        });
                    }
                }, 500);
            });
        });
    }

    if (accordions) {
        handleAccordionsItems(accordions);
    }
    if (accordions2) {
        handleAccordionsItems(accordions2);
    }
}

/* bouton scroll top */
function btnScrolltop() {
    const elem__btnScrollTop = document.querySelector(".btn-scroll-top");

    if (elem__btnScrollTop) {
        elem__btnScrollTop.addEventListener("click", () => {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        });

        window.addEventListener("scroll", toggleScrollToTopButton);

        function toggleScrollToTopButton() {
            if (window.scrollY > 0) {
                elem__btnScrollTop.classList.add("visible");
            } else {
                elem__btnScrollTop.classList.remove("visible");
            }
        }
    }
}


/* sur la page DDD fermer le menu tel en mobile quand on clique en dehors  */

function closeTelMenuMobile() {
    const elem__menuTelBtn = document.querySelector(".menutelmobileddd");
    const elem__menuTelWrapper = document.querySelector(".agence-container");

    function closeMenuTel(event) {
        if (!elem__menuTelWrapper.contains(event.target)) {
            elem__menuTelWrapper.classList.add("hide");
            elem__menuTelWrapper.style.display = "none";
            document.removeEventListener("click", closeMenuTel);
        }
    }

    if (elem__menuTelBtn) {
        elem__menuTelBtn.addEventListener("click", (event) => {
            event.stopPropagation();
            if (elem__menuTelWrapper.classList.contains("hide")) {
                elem__menuTelWrapper.classList.remove("hide");
            }
            document.addEventListener("click", closeMenuTel);
        });
    }
}

/* cacher la div input-city quand on clique en dehors et la reafficher quand on clique dans l'input */

function hideInputCityClickOutside() {
    const elem__inputSearchAgency = document.querySelector(
        "#form-field-communeHome"
    );
    const elem__inputSearchAgency2 = document.querySelector("#addressInput");
    const elem__inputCity = document.querySelector(".input-city");

    function closeInputCityClick(event, targetElement) {
        if (
            !elem__inputCity.contains(event.target) &&
            !targetElement.contains(event.target)
        ) {
            elem__inputCity.classList.add("hide");
            document.removeEventListener("click", () =>
                closeInputCityClick(event, targetElement)
            );
        }
    }

    function handleInputEvent(inputElement) {
        inputElement.addEventListener("input", () => {
            if (
                elem__inputCity.classList.contains("hide") &&
                inputElement.value.length > 3
            ) {
                elem__inputCity.classList.remove("hide");
            } else if (
                !elem__inputCity.classList.contains("hide") &&
                inputElement.value.length < 4
            ) {
                elem__inputCity.classList.add("hide");
            }
            document.addEventListener("click", (event) =>
                closeInputCityClick(event, inputElement)
            );
        });

        inputElement.addEventListener("click", () => {
            if (
                inputElement.value.length > 3 &&
                elem__inputCity.classList.contains("hide")
            ) {
                elem__inputCity.classList.remove("hide");
                document.addEventListener("click", (event) =>
                    closeInputCityClick(event, inputElement)
                );
            }
        });
    }

    if (elem__inputSearchAgency) {
        handleInputEvent(elem__inputSearchAgency);
    }

    if (elem__inputSearchAgency2) {
        handleInputEvent(elem__inputSearchAgency2);
    }
}

function handleRightContentWidthDemandeDeDevis() {
    //demande de devis conteneur droit position fixed mais width relative à la div parente
    const elem__parentDivDevis = document.querySelector(
        ".devis-container .right-section"
    );
    const elem__childDivDevis = document.querySelector(
        ".devis-container .right-section .right-container"
    );

    if (elem__parentDivDevis && elem__childDivDevis) {

        elem__childDivDevis.style.width = elem__parentDivDevis.offsetWidth + "px";

        window.addEventListener("resize", () => {
            elem__childDivDevis.style.width =
                elem__parentDivDevis.offsetWidth + "px";
        });
    }
}

function tabindex() {
    let top_level_menu = document.querySelector(".top-level-menu");
    let menuPanels = document.querySelectorAll(".elementskit-megamenu-panel");
    let top_level_menu_items = top_level_menu.querySelectorAll(
        ".ekit-menu-nav-link"
    );
    if (top_level_menu) {
        for (let i = 0; i < top_level_menu_items.length - 2; i++) {
            let menuItem = top_level_menu_items[i];
            let menuPanel = menuPanels[i];
            menuItem.setAttribute("tabindex", "0");
            keyboardBehavior(
                top_level_menu_items,
                menuPanels,
                menuItem,
                menuPanel,
                i
            );
        }
    }
}

function keyboardBehavior(
    top_level_menu_items,
    menuPanels,
    menuItem,
    menuPanel,
    i
) {
    menuItem.addEventListener(
        "keydown",
        tool.throttle(function (e) {
            let parentPanel = menuPanel.closest(selectors.megamenuPanel);
            let submenu = document.querySelector(".elementskit-submenu-panel");
            let link = submenu.querySelectorAll(".dropdown-item");
            switch (e.key) {
                case "Enter":
                case "13":
                    if (parentPanel) {
                        if (submenu && i === 2) {
                            forceMegaMenuClose();
                            submenu.classList.toggle("ekit-dropdown-open-onclick");
                            for (let j = 0; j < link.length; j++) {
                                link[j].setAttribute("tabindex", "0");
                                link[j].focus();
                            }
                        } else if (
                            !parentPanel.classList.contains("ekit-menu-dropdown-toggle") &&
                            i <= 1
                        ) {
                            parentPanel.classList.toggle("ekit-dropdown-open-onclick");
                        }
                    }
                    break;
                case "Escape":
                case "27":
                    forceMegaMenuClose();
                    if (document.querySelectorAll(".ekit-dropdown-open-onclick")) {
                        document
                            .querySelectorAll(".ekit-dropdown-open-onclick")
                            .forEach(function (el) {
                                el.classList.remove("ekit-dropdown-open-onclick");
                            });
                    } else if (submenu) {
                        submenu.classList.remove("ekit-dropdown-open-onclick");
                    }
                    break;
            }
        }, 50)
    );
}

const forceMegaMenuClose = () => {
    document.querySelectorAll(`.${classes.menuOpened}`).forEach(function (el) {
        el.classList.remove(classes.menuOpened);
    });
};


function fixInputAgencyFirefox() {
    const elem__findAgencyParent = document.querySelector(
        ".find-agency-form .elementor-field-type-html"
    );
    if (elem__findAgencyParent) {
        const elem__findAgencyChild =
            elem__findAgencyParent.querySelector(".input-city");
        if (elem__findAgencyChild) {
            elem__findAgencyParent.classList.add("find-agency-input-mozilla-fix");
        }
    }
}


function allowControlCarouselVideo() {
    let currentIframe = null;
    const startTime = Date.now();

    const checkForElement = () => {
        const elapsedTime = Date.now() - startTime;
        const elem__imgCarouselVideoMedia = document.querySelectorAll(
            ".elementor-carousel-image"
        );

        if (elem__imgCarouselVideoMedia.length > 0) {
            elem__imgCarouselVideoMedia.forEach((el) => {
                el.addEventListener("click", () => {
                    const checkForVideoElement = () => {
                        const elem__videoCarouselVideoMedia = document.querySelector(
                            ".swiper-wrapper iframe"
                        );
                        if (elem__videoCarouselVideoMedia) {
                            const elem__previousArrow = document.querySelector(
                                '.dialog-message [aria-label="Previous slide"]'
                            );
                            const elem__nextArrow = document.querySelector(
                                '.dialog-message [aria-label="Next slide"]'
                            );

                            let currentSrc = elem__videoCarouselVideoMedia.src;
                            if (currentSrc.includes("controls=0")) {
                                let newSrc = currentSrc.replace("controls=0", "controls=1");
                                elem__videoCarouselVideoMedia.src = newSrc;
                            }
                            elem__previousArrow.addEventListener("click", () => {
                                waitForNewVideo();
                            });

                            elem__nextArrow.addEventListener("click", () => {
                                waitForNewVideo();
                            });

                            if (
                                !elem__previousArrow.classList.contains(
                                    "fix-video-carousel-arrow"
                                )
                            ) {
                                elem__previousArrow.classList.add("fix-video-carousel-arrow");
                                elem__nextArrow.classList.add("fix-video-carousel-arrow");
                            }

                            currentIframe = elem__videoCarouselVideoMedia;
                        } else {
                            if (elapsedTime < 5000) {
                                setTimeout(checkForVideoElement, 100);
                            }
                        }
                    };
                    checkForVideoElement();
                });
            });
        } else {
            if (elapsedTime < 5000) {
                setTimeout(checkForElement, 100);
            }
        }
    };

    const waitForNewVideo = () => {
        const checkNewVideo = () => {
            const elem__videoCarouselVideoMedia = document.querySelector(
                ".swiper-wrapper iframe"
            );
            if (
                elem__videoCarouselVideoMedia &&
                elem__videoCarouselVideoMedia !== currentIframe
            ) {
                let currentSrc = elem__videoCarouselVideoMedia.src;
                if (currentSrc.includes("controls=0")) {
                    let newSrc = currentSrc.replace("controls=0", "controls=1");
                    elem__videoCarouselVideoMedia.src = newSrc;
                }

                currentIframe = elem__videoCarouselVideoMedia;
            } else {
                setTimeout(checkNewVideo, 100); // Attendre et vérifier à nouveau
            }
        };
        checkNewVideo();
    };

    checkForElement();
}

function fixInfoBulleScroll() {
    const elem__infobulles = document.querySelectorAll(
        'a[href="#elementor-action%3Aaction%3Dpopup%3Aopen%26settings%3DeyJpZCI6IjM0NjE0IiwidG9nZ2xlIjpmYWxzZX0%3D"]'
    );
    if (elem__infobulles) {
        elem__infobulles.forEach((el) => {
            el.addEventListener("click", () => {
                setTimeout(() => {
                    const elem__modalInfobulles = document.querySelector(
                        "#elementor-popup-modal-34614"
                    );
                    elem__modalInfobulles.addEventListener("click", function () {
                        window.scrollTo(window.scrollX, window.scrollY);
                    });
                }, 500);
            });
        });
    }
}


function hideBtnThanksPage() {
    const elem__thanksContainer = document.querySelector(
        ".remerciement-container"
    );
    if (elem__thanksContainer) {
        tool.waitForElem('.elementor-element-11fb0e7').then((r) => {
            const elem__headerLeaveBtn = document.querySelector(
                ".elementor-element-11fb0e7"
            );
            elem__headerLeaveBtn.classList.add("deactivate");
        });
    }
}


function swiperRole() {
    tool.waitForElem(".hero-swiper").then((r) => {
        tool.waitForElem(".swiper-pagination-bullet", r).then((s) => {
            let sw = r.querySelectorAll(".swiper-pagination-bullet");
            sw.forEach((bullet) => bullet.setAttribute("role", "button"));
        });
    });
}

function mediaCarousel() {
    tool.waitForElem("#carrousel-media-menage").then((r) => {
        let carouselItems = r.querySelectorAll("a");
        carouselItems.forEach((item) => item.setAttribute("tabindex", "-1"));
    });
}

function removeCategoyLinkSitemap() {
    //Sélectionne tous les titres catégories
    let categories = document.querySelectorAll(".wsp-category-title");

    //Boucle sur chaque élément
    categories.forEach(function (category) {
        // Récupère le contenu de chaque titre
        var categorieContent = category.innerHTML;

        //Enlever les balises <a> du contenu
        var cleanCategorie = categorieContent.replace(/<(\/*)a[^>]*>/g, "");

        // Mettre à jour le contenu du paragraphe sans les balises <a>
        category.innerHTML = cleanCategorie;
    });
}


function homeSL_NoEnter() {
    let input = document.querySelector("#form-field-communeHome");
    input.addEventListener("keydown", function (e) {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    });
}

function megamenuBehavior() {
    const selectors = {
        menuItem: ".menu-item a",
        megamenuItem: "[js-megamenu-item]",
        megamenuPanel: ".elementskit-megamenu-panel",
        megamenuClose: "[js-close-menu]",
        megamenuHidden: "[js-megamenu-hidden]",
        openerHiddenMegamenu: ".js-opener-hidden-megamenu.menu-item",
        mobileItemHasMegamenu: "#menu-menu-mobile .elementskit-megamenu-has",
    };

    // Fermer le Megamenu
    document.querySelectorAll(selectors.megamenuClose).forEach(function (el) {
        el.addEventListener(
            "click",
            tool.throttle(function () {
                const parent = this.closest(selectors.megamenuPanel);
                if (parent.classList.contains(classes.menuOpened)) {
                    parent.classList.remove(classes.menuOpened);
                }
                if (parent.classList.contains(classes.dropdownOpened)) {
                    parent.classList.remove(classes.dropdownOpened);
                }
            }, 50)
        );
        el.addEventListener(
            "keydown",
            tool.throttle(function (e) {
                if (
                    e.key === "Escape" ||
                    e.keyCode === 27 ||
                    e.key === "Enter" ||
                    e.keyCode === 13
                ) {
                    const parent = this.closest(selectors.megamenuPanel);
                    if (parent.classList.contains(classes.menuOpened)) {
                        parent.classList.remove(classes.menuOpened);
                    }
                    if (parent.classList.contains(classes.dropdownOpened)) {
                        parent.classList.remove(classes.dropdownOpened);
                    }
                }
            }, 50)
        );
    });


    const megamenuHidden = document.querySelectorAll(selectors.megamenuHidden);
    const openerHiddenMegamenu = document.querySelectorAll(
        selectors.openerHiddenMegamenu
    );
    const mobileItemHasMegamenu = document.querySelectorAll(
        selectors.mobileItemHasMegamenu
    );

    //Handle submenus on mobile
    if (mobileItemHasMegamenu.length) {
        mobileItemHasMegamenu.forEach(function (el) {
            el.addEventListener(
                "click",
                tool.throttle(function (e) {
                    if (e.target.nodeName === "A") {
                        el.querySelector(selectors.megamenuPanel).classList.add(
                            classes.dropdownOpened
                        );
                    }
                }, 50)
            );
        });
    }

    //Handle submenus on desktop
    if (megamenuHidden && openerHiddenMegamenu) {
        openerHiddenMegamenu.forEach(function (el, index) {
            el.addEventListener(
                "click",
                tool.throttle(function () {
                    forceMegaMenuClose();
                    megamenuHidden[index]
                        .closest(selectors.megamenuPanel)
                        .classList.add(classes.menuOpened);
                }, 50)
            );
            el.addEventListener(
                "keydown",
                tool.throttle(function (e) {
                    if (e.key === "Enter" || e.keyCode === 13) {
                        forceMegaMenuClose();
                        megamenuHidden[index]
                            .closest(selectors.megamenuPanel)
                            .classList.add(classes.menuOpened);
                    }
                }, 50)
            );
        });
    }

    let lastMenuItemClicked = null

    document.querySelectorAll(selectors.menuItem).forEach(function (el) {
        el.addEventListener(
            "click",
            tool.throttle(function (e) {
                if (this !== e.target) {
                    return;
                }
                forceMegaMenuClose();
                if (lastMenuItemClicked === el) {
                    el.nextElementSibling.classList.toggle('ekit-dropdown-open-onclick')
                    lastMenuItemClicked = null
                } else {
                    lastMenuItemClicked = el
                }
            }, 50)
        );
        el.addEventListener(
            "keydown",
            tool.throttle(function (e) {
                if (e.key === "Enter" || e.keyCode === 13) {
                    if (this !== e.target) {
                        return;
                    }
                    forceMegaMenuClose();
                    if (lastMenuItemClicked === el) {
                        el.nextElementSibling.classList.toggle('ekit-dropdown-open-onclick')
                        lastMenuItemClicked = null
                    } else {
                        lastMenuItemClicked = el
                    }
                }
            }, 50)
        );
    });

    //ajout tabindex sur les liens du megamenu

    //force la fermeture du megamenu
    if (document.querySelectorAll(".ekit-dropdown-open-onclick")) {
        document.addEventListener(
            "keydown",
            tool.throttle(function (e) {
                if (e.key === "Escape" || e.keyCode === 27) {
                    document
                        .querySelectorAll(".ekit-dropdown-open-onclick")
                        .forEach(function (el) {
                            el.classList.remove("ekit-dropdown-open-onclick");
                        });
                }
            }, 50)
        );
    }

    //fin Menu
}

function initCommentCaMarcheSlider() {
    const commentCaMarcheSlider = document.querySelector('[js-comment-ça-marche-slider]');

    if (commentCaMarcheSlider) {
        const swiper = new Swiper(commentCaMarcheSlider, {
            modules: [Pagination],
            init: false,
            speed: 500,
            effect: 'slide',
            slidesPerView: 1.2,
            spaceBetween: 16,
            grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.5,
                    spaceBetween: 24
                },
                1280: {
                    slidesPerView: 4
                },
            },
        });

        swiper.init();
    }
}

function initAggloSlider() {
    const aggloSlider = document.querySelector('[js-agglo_mobile-slider]');

    if (aggloSlider) {
        const swiper = new Swiper(aggloSlider, {
            modules: [Pagination],
            init: false,
            speed: 500,
            effect: 'slide',
            slidesPerView: 1.2,
            spaceBetween: 16,
            grabCursor: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.5,
                    spaceBetween: 24
                },
                1280: {
                    slidesPerView: 4
                },
            },
        });

        swiper.init();
    }
}

function scrollIntoViewAgglo(){
    if (window.location.hash === "#listingAgence") {
        setTimeout(() => {
            const target = document.getElementById("bloc-listing-agency");
            if (target) {
                window.scrollTo({
                    top: target.offsetTop,
                    behavior: "smooth"
                });
            }
        }, 100)
    }
}

function initCarouselServiceSlider() {
    const carouselServiceSlider = document.querySelector('.carousel-service-slider');

    if (carouselServiceSlider) {
        const swiperCarouselService = new Swiper(carouselServiceSlider, {
            modules: [Pagination, Navigation],
            init: false,
            speed: 500,
            effect: 'slide',
            slidesPerView: 1,
            spaceBetween: 20,
            grabCursor: true,
            navigation: {
                nextEl: ".carousel-service-next",
                prevEl: ".carousel-service-prev",
            },
            pagination: {
                el: '.swiper-pagination-carousel-service',
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                },
                1400: {
                    slidesPerView: 4,
                },
            },
        });

        swiperCarouselService.init();
    }
}

function hideBannerOffreMenage() {
    var UrlNow = window.location.href;

    const Urlban = [
        '/aide-a-domicile/',
        '/garde-denfant/',
        "/merci-devis-offre-speciale/",
        "/merci-demande-de-devis/",
        "/journee-aides-domicile-salaries/"
    ]
    if (Urlban.some(url => UrlNow.includes(url))) {

        const banner = document.getElementById('banner_ddd_cred_impot');
        const isUrlMatched = Urlban.some(url => UrlNow.includes(url));

        banner.style.display = isUrlMatched ? 'none' : 'block';
    }
}


export {
    hideBannerOffreMenage,
    scrollIfAccordionNotVisible,
    simulateClickSummaryBlog,
    overrideScrollTableOfContents,
    watchClassChange,
    closeTelMenuMobile,
    hideInputCityClickOutside,
    handleRightContentWidthDemandeDeDevis,
    btnScrolltop,
    tabindex,
    keyboardBehavior,
    fixInputAgencyFirefox,
    allowControlCarouselVideo,
    fixInfoBulleScroll,
    hideBtnThanksPage,
    swiperRole,
    mediaCarousel,
    removeCategoyLinkSitemap,
    homeSL_NoEnter,
    megamenuBehavior,
    addOpacityOnClickMegamenu,
    handleFixedHeader,
    initCommentCaMarcheSlider,
    initAggloSlider,
    initCarouselServiceSlider,
    scrollIntoViewAgglo,
}